export default "__VITE_ASSET__CVunlLyA__"